import { accountConstants } from '../constants'

export const accountLoad = () => {
  return {
    type: accountConstants.ACCOUNT_LOAD
  }
}

export const accountLoadSuccess = (payload) => {
  return {
    type: accountConstants.ACCOUNT_LOAD_SUCCESS,
    payload
  }
}

export const accountLoadFailure = (payload) => {
  return {
    type: accountConstants.ACCOUNT_LOAD_FAILURE,
    payload
  }
}

export const accountReset = () => {
  return {
    type: accountConstants.ACCOUNT_RESET
  }
}

export const accountSave = (payload) => {
  return {
    type: accountConstants.ACCOUNT_SAVE,
    payload
  }
}

export const accountSaveSuccess = (payload) => {
  return {
    type: accountConstants.ACCOUNT_SAVE_SUCCESS,
    payload
  }
}

export const accountSaveFailure = (payload) => {
  return {
    type: accountConstants.ACCOUNT_SAVE_FAILURE,
    payload
  }
}

export const accountDelete = (payload) => {
  return {
    type: accountConstants.ACCOUNT_DELETE,
    payload
  }
}

export const accountDeleteSuccess = (payload) => {
  return {
    type: accountConstants.ACCOUNT_DELETE_SUCCESS,
    payload
  }
}

export const accountDeleteFailure = (payload) => {
  return {
    type: accountConstants.ACCOUNT_DELETE_FAILURE,
    payload
  }
}